import Component from './campaign_prize_dialog.vue'
export default Component
